module.exports = __webpack_public_path__ + "media/images/pc/top/recommend_plan_photowedding@2x-d430e642cb6171ff83afb49bfa769637.webp";